import { Wording } from '@/types';

export const FITNESS_WORDING_SI: Wording = {
  components_header_media_content: 'Vadbe',
  components_header_media_1: 'Za moške',
  components_header_media_2: 'Za ženske',
  components_header_text1: 'Recepti',
  components_header_text2: 'Blog',
  components_header_members: 'Člani',
  hero_text: 'Ohranite svoje telo v formi in močno',
  hero_button_text: 'Začnite svojo pot do fitnesa',
  components_ressources_section_title: 'VIRI',
  components_ressources_subheader_text: 'Vsi viri, ki jih potrebujete za zdravo življenje',
  components_ressources_span_text: 'Negujte svoje dobro počutje: Sprostite bogastvo virov za celostno zdravje in polno življenje, vključno s strokovnim svetovanjem o telesni pripravljenosti, prehrani in trajnostnem načinu življenja.',
  components_ressources_card_1_title: 'Motivacija',
  components_ressources_card_1_text: 'Kratki izbruhi motivacije za trajne vadbene navade.',
  components_ressources_card_2_title: 'Dieta',
  components_ressources_card_2_text: 'Pametni nasveti za prehrano za bolj zdravega in močnejšega sebe.',
  components_ressources_link: 'Oglejte si videoposnetke',
  components_notes_and_google_title_1: 'Fitnes trening',
  components_notes_and_google_title_2: 'Redna rutina',
  components_notes_and_google_title_3: 'Vzdrževanje prehrane',
  components_review_google_text: 'Ocena na Googlu',
  media_content_section_title: 'VADBE',
  media_content_section_subheader_text: 'Naši videoposnetki',
  text_media_1: 'Moški',
  text_media_2: 'Ženske',
  media_content_section_button_more: 'Več videoposnetkov',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članki in novice',
  text2_section_button_more: 'Več člankov',
  components_text1_section_title: 'RECEPTI',
  components_text1_subheader_text: 'Zdrava prehrana za vaše aktivno življenje',
  components_text1_span_text: 'Pripravite si vitalnost: Raziščite svet okusne telesne pripravljenosti z našimi hitrimi in hranilno bogatimi recepti.',
  components_text1_card_1_title: 'Začnite svoj dan',
  components_text1_card_1_text: 'Začnite svoja jutra pravilno s hranljivimi in beljakovinami bogatimi zajtrki.',
  components_text1_card_3_title: 'Kosila z veliko energije',
  components_text1_card_3_text: 'Odkrijte okusne in priročne recepte za kosilo, zasnovane za vaš aktivni življenjski slog. Od pisanih solat do beljakovinsko bogatih zavitkov, ti recepti vas bodo napolnili z energijo in vam zagotovili osredotočenost.',
  components_text1_card_2_title: 'Večerje za okrevanje',
  components_text1_card_2_text: 'Za zadovoljiv zaključek dneva raziščite različne puste beljakovine, polnozrnata žita in živahno zelenjavo.',
  components_text1_link: 'Oglejte si vse recepte',
  components_footer_text: 'Dvignite svojo moč, prebudite svojo strast: Vaša telovadnica, vaša preobrazba.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registrska številka',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Pogoji poslovanja',
  components_footer_privacy: 'Pravilnik o zasebnosti',
  button_load_more: 'Naloži več',
  page_media_1_content_hero_text: 'Moške vadbe',
  page_media_content_menu_biceps: 'Bicepsi',
  page_media_content_menu_triceps: 'Tricepsi',
  page_media_content_menu_back: 'Nazaj',
  page_media_content_menu_chest: 'Prsni koš',
  page_media_content_menu_legs: 'Noge',
  page_media_content_menu_shoulders: 'Ramena',
  page_media_content_menu_abdominals: 'Trebušne mišice',
  page_media_2_content_hero_text: 'Ženske vadbe',
  page_text1_hero_text: 'Recepti',
  page_text1_section_title: 'Prehrana',
  page_text1_subheader_text: 'Recepti',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članki in novice',
  enter_email_title: 'Za nadaljevanje vnesite svoj e-poštni naslov',
  enter_email_placeholder_email: 'E-pošta',
  enter_email_button_enter: 'Vnesite',
  components_login_success_text: 'Prijava uspešna!',
  components_card_link_media_content: 'Oglejte si zdaj',
  components_card_link_text1_content: 'Ogled recepta',
  components_card_link_text2_content: 'Ogled članka',
  france: 'Francija',
  cyprus: 'Ciper',
  page_media_content_menu_all: 'VSE',
};